module.exports = __webpack_public_path__ + "static/img/center-banner.61f9316.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/center-banner.png
// module id = 4/wO
// module chunks = 1